export default __webpack_public_path__ + "static/media/favicon.29ff1379.ico";